import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import { DELETE } from "../tools/actions/ActionHelper";
import EventTypes from "../shared/EventTypes";
import { addSvg } from "../shared/utils";

export default class ElementRow extends AbstractProvidedClass {
    constructor(provider, element) {
        super(provider);

        this.element = element;

        this.row = this.p.createDiv()
            .parent(this.getTab('elements').rowContainer)
            .class('input-search-result')
            .mouseOver(() => this.mouseOver())
            .mouseOut(() => this.mouseOut())
            .mouseClicked(() => this.click());

        this.img = this.p.createElement('div')
            .parent(this.row)
            .class('data-img-xs align-center');
        this.label = this.p.createElement('label', '')
            .class('input-search-result-name align-center')
            .parent(this.row);

        this.element.row = this;
        this.updateImg();
        this.updateLabel();
        this.createOptions();
    }

    mouseOver() {
        if (this.touch) return;
        this.hoverSet.add(this.element);
        this.label.hide();
        this.options.show();
    }

    mouseOut() {
        if (this.touch) return;
        this.hoverSet.reset();
        this.label.show();
        this.options.hide();
    }

    updateImg() {
        let max = 37;
        this.img.html('');
        let svg = SVG().addTo(this.img.elt).size(40, 40);
        switch (this.element.type) {
            case 'rectangle':
                let rect = svg.rect(
                    ...this.element.getMiniView(max)
                ).cx(20).cy(20);
                this.element.appearance.applyToSvg(rect);
                break;
            case 'ellipse':
                let ellipse = svg.ellipse(37, 37).cx(20).cy(20);
                this.element.appearance.applyToSvg(ellipse);
                break;
            case 'line':
                let polyline = svg.polyline(
                    this.element.getMiniView(max)
                );
                this.element.appearance.applyToSvg(polyline);
                break;
            case 'polygon':
                let polygon = svg.polygon(
                    this.element.getMiniView(max)
                );
                this.element.appearance.applyToSvg(polygon);
                break;
            default:
        }
    }

    updateLabel() {
        this.label.html(`${this.element.name} <span>${this.element.secondaryName}</span>`);
    }

    click() {
        if (this.buttonClicked) {
            return;
        }
        this.hoverSet.reset();
        if (this.viewMode) {
            this.element.selected
                ? this.selection.remove(this.element)
                : this.selection.select(this.element);
        } else {
            this.selection.click(this.element);
        }
    }

    createOptions() {
        this.options = this.p.createDiv()
            .parent(this.row);
        this.optionsContainer = this.p.createDiv()
            .parent(this.options)
            .class('row');

        this.options.hide();

        this.infoButton = this.createButton('Info', () => this.goToInfo(), 'information-line');
        if (this.editMode) {
            this.deleteButton = this.createButton('Delete', () => this.deleteElement(), 'close-circle-line');
        }

        if (this.touch) {
            if (this.viewMode) {
                // In view mode only the info button exists — show it directly
                this.label.hide();
                this.options.show();
            } else {
                this.moreButton = this.p.createDiv()
                    .parent(this.row)
                    .class('btn-icon')
                    .style('margin-left', 'auto')
                    .mouseClicked(() => this.toggleRowOptions());
                addSvg(this.moreButton, 'more-2-fill');
                this.on(EventTypes.CLOSE_SIDEBAR, () => this.closeRowOptions());
            }
        }
    }

    openRowOptions() {
        this.label.hide();
        this.moreButton.hide();
        this.options.show();
        this.hoverSet.add(this.element);
        this._closeHandler = (e) => {
            if (!this.row.elt.contains(e.target)) {
                this.closeRowOptions();
            }
        };
        setTimeout(() => document.addEventListener('touchstart', this._closeHandler), 0);
    }

    closeRowOptions() {
        if (this._closeHandler) {
            document.removeEventListener('touchstart', this._closeHandler);
            this._closeHandler = null;
        }
        this.label.show();
        this.moreButton.show();
        this.options.hide();
        this.hoverSet.reset();
    }

    toggleRowOptions() {
        if (this.options.elt.style.display === 'none') {
            this.openRowOptions();
        } else {
            this.closeRowOptions();
        }
    }

    createButton(toolTip, func, svgId) {
        let btn = this.p.createDiv()
            .parent(this.optionsContainer)
            .class('btn-icon mar-l-xs')
            .attribute('data-tooltip', toolTip)
            .mouseClicked(func);
        let svg = SVG().addTo(btn.elt);
        svg.use(svgId, '/icons/__remixicon.sprite.svg');
        return btn;
    }

    goToInfo() {
        this.clickButton();
        this.selection.select(this.element);
        this.sideBar.setTab('info');
    }

    deleteElement() {
        this.clickButton();
        this.actions.execute(DELETE, [this.element]);
    }

    clickButton() {
        this.buttonClicked = true;
        setTimeout(() => this.buttonClicked = false, 100);
    }

    delete() {
        this.row.remove();
    }

    show() {
        this.row.show();
    }

    hide() {
        this.row.hide();
    }

    select() {
        this.row.style('background-color', '#aebbf240');
    }

    deselect() {
        this.row.style('background-color', null);
    }
}
